import { createIntl, createIntlCache } from "react-intl";
import svMessages from "./sv.json";
import enMessages from "./en.json";
import dkMessages from "./dk.json";

function flattenMessages(nestedMessages, prefix = "") {
  return Object.keys(nestedMessages).reduce((messages, key) => {
    let value = nestedMessages[key];
    let prefixedKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === "string") {
      messages[prefixedKey] = value;
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }

    return messages;
  }, {});
}

const messages = {
  sv: flattenMessages(svMessages),
  en: flattenMessages(enMessages),
  dk: flattenMessages(dkMessages),
};

// Default locale is Swedish
const defaultLocale = window.location.hostname.includes(".dk.") ? "dk" : "sv";
// const defaultLocale = "dk";

// Create cache for better performance
const cache = createIntlCache();

// Create intl instance
export const intl = createIntl(
  {
    locale: defaultLocale,
    messages: messages[defaultLocale],
  },
  cache,
);

export { messages, defaultLocale };
